<template>
  <CDataTable
      :fields="fields"
      :items="items"
      border
  >
    <!--    <template #pMeaning="{item}">-->
    <!--      <td>-->
    <!--        {{item.pMeaning}}-->
    <!--      </td>-->
    <!--    </template>-->
    <!--    <template #dMeaning="{item}">-->
    <!--      <td>-->
    <!--        {{item.dMeaning}}-->
    <!--      </td>-->
    <!--    </template>-->
  </CDataTable>
</template>

<script>
export default {
  name: 'InterpretationTable',
  props: {
    fields: Array,
    items: Array
  }
}
</script>
